export const yesNoOptions = [
    { label: 'No', value: false },
    { label: 'Yes', value: true },
]

export const yesNoOptions01 = [
    { label: 'No', value: '0' },
    { label: 'Yes', value: '1' },
]

export const translateFunctionOptions = [
    { label: 'Cast', value: 'CAST' },
    { label: 'Value if Empty', value: 'ISNULL' },
]

export const translateArgumentOptions = [
    { label: 'INTEGER', value: 'INT' },
    { label: 'FLOAT', value: 'FLOAT' },
    { label: 'STRING', value: 'VARCHAR' },
]

export const aggregateFunctionOptions = [
    { label: 'SUM', value: 'SUM' },
    { label: 'AVG', value: 'AVG' },
    { label: 'COUNT', value: 'COUNT' },
    { label: 'COUNT DISTINCT', value: 'COUNT DISTINCT' },
    { label: 'MIN', value: 'MIN' },
    { label: 'MAX', value: 'MAX' },
]

export const orderByFunctionOptions = [
    { label: 'ASC', value: 'ASC' },
    { label: 'DESC', value: 'DESC' },
]

export const joinTypeOptions = [
    { label: 'Inner', value: 'INNER' },
    { label: 'Left', value: 'LEFT' },
]